export default __webpack_public_path__ + "static/media/pic2.44753568.jpg";